import axios from 'axios';

export class ApiError extends Error {
  constructor({ message, status = 0, code = 'UNKNOWN', details, requestId, cause }) {
    super(message, { cause });
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.requestId = requestId;
  }
}

export function toApiError(error) {
  if (error instanceof ApiError || axios.isCancel(error)) return error;

  return new ApiError({
    message:
      error.response?.data?.message ??
      (error.request ? 'Unable to reach the server.' : 'Unexpected request error.'),
    status: error.response?.status ?? 0,
    code: error.response?.data?.code ?? error.code ?? 'UNKNOWN',
    details: error.response?.data?.errors,
    requestId: error.response?.headers?.['x-request-id'],
    cause: error,
  });
}
